module.exports = __webpack_public_path__ + "9788f41e/img/trash-icon.ff8201c7.svg";